import { render, staticRenderFns } from "./NotificationWalletTransferAction.vue?vue&type=template&id=e677b054"
import script from "./NotificationWalletTransferAction.vue?vue&type=script&lang=js"
export * from "./NotificationWalletTransferAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports